module.exports = __webpack_public_path__ + "img/token-swap-fill.5310e03f.svg";